import { initFancybox } from '@js/common/fancybox.js';
initFancybox();